G.UI_OptInIcon = function(x,y) {

	this.state = game.state.getCurrentState();
	
	Phaser.Group.call(this,game);
	
	this.x = G.l(x);
	this.y = G.l(y);

	this._addIcon();
  this.notificationBubble = new G.NotificationBubble(30, -30);
  this.add(this.notificationBubble);

	this.update();

	G.sb("onScreenResize").add(this.onResize,this);
	this.onResize();
	
};

G.UI_OptInIcon.prototype = Object.create(Phaser.Group.prototype);

G.UI_OptInIcon.prototype.update = function() {
	this.active = G.saveState.data.showOptinIcon;
	if (this.active) {
		if( typeof G.saveState.data.seenOptinIcon !== 'boolean' && G.saveState.data.seenOptinIcon === false ) {
			G.saveState.data.seenOptinIcon = true;
		}
		this.notificationBubble.setImportant(true);
    this.icon.visible = true;
	} else {
		this.notificationBubble.setImportant(false);
    this.icon.visible = false;
  }
};

G.UI_OptInIcon.prototype.onResize = function(){

	var center = game.world.bounds.x+Math.floor(game.width*0.5);
	this.x = center-260;
	this.y = game.height * 215/300;;

};

G.UI_OptInIcon.prototype._addIcon = function (){
	this.icon = new G.Button(0,0,'Subscribe_icon',function() {
		if (!this.active) return;
		G.sb("pushWindow").dispatch(["botOptIn", function (){}, this]);
	},this);
	this.add(this.icon);
};
